import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/mirissa-2.png";

import bus from "../assets/bus.png";

import galleImg from "../assets/galle-1.jpg";
import safariImg from "../assets/udawalawe-2.png";
import diyalumaImg from "../assets/diyalumaFalls-1.jpg";
import whaleImg from "../assets/whale-watching-mirissa-sri-lanka.jpg";
import divingImg from "../assets/Diving.jpg";

function DayTours() {

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    const tours = [
        {
            title: "Galle Day Trip",
            img: galleImg,
            highlights: [
                "Galle Fort",
                "Tea Plantation",
                "Cinnamon Experience",
                "Stilt Fishermen",
                "Optional Boat Tour",
            ],
            price: "From Rs. 32,000 (2 people)",
            includes: "Entrance tickets, transport, driver",
        },
        {
            title: "Safari Day Trip (Udawalawe / Yala)",
            img: safariImg,
            highlights: [
                "Udawalawe Safari",
                "Yala Safari",
                "Private Jeep",
                "Fruit Platter",
            ],
            price: "Udawalawe: Rs. 60,000 | Yala: Rs. 67,000",
            includes:
                "Entrance ticket, private jeep, transport to/from Ahangama, fruit platter",
        },
        {
            title: "Upper Diyaluma Waterfall Day Trip",
            img: diyalumaImg,
            highlights: [
                "Waterfall Adventure",
                "Nature Experience",
                "Scenic Views",
                "Guided Tour",
            ],
            price: "Rs. 48,000 (2 people)",
            includes: "Entrance ticket, guide, transport",
        },
        {
            title: "Whale Watching (Mirissa | 5–6 Hours)",
            img: whaleImg,
            highlights: [
                "Blue Whale Watching",
                "Boat Tour",
                "Mirissa Harbor",
                "Ocean Experience",
            ],
            price: "Rs. 47,000 (2 people)",
            includes: "Car, port fees, tickets, small snack",
        },
        {
            title: "Hikkaduwa Diving / Snorkelling",
            img: divingImg,
            highlights: [
                "Snorkelling (1.5 Hours): $20",
                "Discover Scuba: $80",
                "Licensed Divers (2 Dives): $75",
                "Transport: + Rs. 20,000",
            ],
            price: "Custom Packages Available",
            includes:
                "Open Water / Advanced license needed for shipwreck dives",
        },
    ];

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${aboutHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
                    <h1 className="mb-4 text-4xl font-extrabold sm:text-5xl md:text-6xl">
                        Day Tours
                    </h1>

                    <p className="max-w-2xl text-sm text-gray-200 sm:text-base">
                        Explore Sri Lanka with unforgettable day tour experiences
                    </p>
                </div>
            </section>

            {/* ================= DAY TOURS SECTION ================= */}
            <section className="bg-gray-50 py-16">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

                    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">

                        {tours.map((tour, index) => (
                            <div
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                                className="overflow-hidden rounded-2xl bg-white shadow-md transition duration-300 hover:-translate-y-1 hover:shadow-2xl"
                            >

                                {/* Image */}
                                <div className="overflow-hidden">
                                    <img
                                        src={tour.img}
                                        alt={tour.title}
                                        className="h-60 w-full object-cover transition duration-500 hover:scale-105"
                                    />
                                </div>

                                {/* Content */}
                                <div className="p-6">

                                    <h3 className="text-xl font-bold text-gray-900">
                                        {tour.title}
                                    </h3>

                                    {/* Highlights */}
                                    <ul className="mt-4 space-y-2 text-sm text-gray-600">
                                        {tour.highlights.map((item, idx) => (
                                            <li key={idx} className="flex items-start gap-2">
                                                <span className="mt-1 h-2 w-2 rounded-full bg-teal-500"></span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>

                                    {/* Price */}
                                    <div className="mt-5 rounded-lg bg-teal-50 p-3">
                                        <p className="text-sm font-semibold text-teal-700">
                                            {tour.price}
                                        </p>
                                    </div>

                                    {/* Includes */}
                                    <p className="mt-4 text-sm leading-relaxed text-gray-600">
                                        <span className="font-semibold text-gray-800">
                                            Includes:
                                        </span>{" "}
                                        {tour.includes}
                                    </p>

                                    {/* Button */}
                                    <a
                                        href={`https://wa.me/94769245905?text=${encodeURIComponent(
                                            `Hello, I would like to book this tour.

                                            Tour: ${tour.title}

                                            Highlights:
                                            ${tour.highlights.map((item) => `• ${item}`).join("\n")}

                                            Price: ${tour.price}

                                            Includes: ${tour.includes}`
                                        )}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mt-6 inline-block rounded-lg bg-black px-5 py-3 text-sm font-medium text-yellow-400 transition hover:bg-gray-900"
                                    >
                                        Book Now
                                    </a>

                                </div>
                            </div>
                        ))}

                    </div>

                </div>
            </section>

            {/* ================= TAXI CTA ================= */}
            <section className="w-full bg-[#f7f7f7] py-16">
                <div className="mx-auto max-w-7xl px-4 grid items-center gap-10 md:grid-cols-2">

                    <div className="text-center">
                        <h2 className="mb-4 text-3xl font-extrabold">
                            Book your Taxi Today!
                        </h2>

                        <p className="mb-6 text-gray-700">
                            RNR Travels & Tours is the best and No.1 Taxi & Tour
                            service provider in Sri Lanka.
                        </p>

                        <p className="mb-6 text-2xl font-bold">
                            +94 76 924 5905
                        </p>

                        <a
                            href="tel:+94769245905"
                            className="inline-block rounded bg-black px-8 py-3 text-yellow-400"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="flex justify-center">
                        <img src={bus} alt="Taxi Service" />
                    </div>

                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94769245905"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src={require("../assets/whatsapp.png")}
                    alt="WhatsApp Icon"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default DayTours;